import Vue from 'vue'
import moment from 'moment'

Vue.filter('date', (value, format = 'DD/MM/YYYY') => {
  return value ? moment(value).format(format) : ''
})



// WEBPACK FOOTER //
// ./src/filters/dateFilter.js